module.exports = __webpack_public_path__ + "static/media/biopic.56de2eb7.jpg";